export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["地址类型"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["账户类型"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["货币"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名称"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建地址"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建账户"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建新地址"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建新账户"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入名称"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择货币"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择类型"])}
}